import { createRouter, createWebHistory } from "vue-router"
import AuthMiddleware from "@/middleware/auth"
const Home = () => import(/* webpackChunkName: "routes" */ "@/views/Home")
const SignIn = () =>
  import(/* webpackChunkName: "routes" */ "@/views/auth/SignIn.vue")
const Profile = () =>
  import(/* webpackChunkName: "routes" */ "@/views/auth/Profile.vue")
const GlobalSearch = () =>
  import(/* webpackChunkName: "routes" */ "@/views/GlobalSearch")
const Exports = () =>
  import(/* webpackChunkName: "routes" */ "@/components/Exports")

const PharmacyExports = () =>
  import(/* webpackChunkName: "routes" */ "@/components/PharmacyExports")

const MultipleBarcodes = () =>
  import(/* webpackChunkName: "routes" */ "@/views/cases/MultipleBarcodes")
const MultipleQrcodes = () =>
  import(/* webpackChunkName: "routes" */ "@/views/cases/MultipleQrcodes")
const OrderMultipleBarcodes = () =>
  import(/* webpackChunkName: "routes" */ "@/views/orders/MultipleBarcodes")
const TestGOOrderBarcode = () =>
  import(/* webpackChunkName: "routes" */ "@/views/orders/TestGOOrderBarcode")
const MultipleTestBarcodes = () =>
  import(/* webpackChunkName: "routes" */ "@/views/cases/MultipleTestBarcodes")
const MultipleExternalLabBarcodes = () =>
  import(
    /* webpackChunkName: "routes" */ "@/views/cases/MultipleExternalLabBarcodes"
  )
const EmailLogs = () =>
  import(/* webpackChunkName: "routes" */ "@/components/emailLogs/AllEmailLogs")

//logs

const CasesLogs = () => import("@/views/logs/CasesLogs")
const OrdersLogs = () => import("@/views/logs/OrdersLogs")
const PrintRequisition = () => import("@/components/orders/PrintRequisition")
const PrintCaseRequisition = () => import("@/components/cases/PrintRequisition")
const EMROrdersLogs = () => import("@/views/logs/EMROrdersLogs")
const ResultFileLogs = () => import("@/views/logs/ResultFileLogs")
const UserAccountLogs = () => import("@/views/logs/UserAccountLogs")
const LoginUserLogs = () => import("@/views/logs/UserLoginLogs")
const SystemLogs = () => import("@/views/logs/SystemLogs")
const InstrumentQueue = () => import("@/views/instrumentQueue/InstrumentQueue")

import { CaseRouter } from "@/router/casesRouter"

import { ResultFilesRouter } from "@/router/resultFilesRouter"

import { QCChartsRouter, QCChartNonChildRoutes } from "@/router/qcCharts"

import { SendOutsRouter } from "@/router/sendOutsRouter"

import { ReceivedSendOutsRouter } from "@/router/receivedSendOutsRouter"

import { HospitalRouter } from "@/router/hospitalRouter"

import { PhysicianRouter } from "@/router/physicianRouter"

import { OrdersRouter } from "@/router/ordersRouter"

import { UserAccountsRouter } from "@/router/userAccountsRouter"

import { PendingCasesRouter } from "@/router/pendingCasesRouter"

import { topdogRouters } from "@/router/topDog"

import { InsurancesRouter } from "@/router/insurances"

import { RuleBookRouter } from "@/router/billingRuleBookRouter"

import { EMRInsurancesRouter } from "@/router/emrInsurances"

import { BillingAutomationRulesRouter } from "@/router/billingAutomationRules"

import { ResendToRxntRouter } from "@/router/resendToRxnt"
import { DataEntryTemplateGenerationRouter } from "@/router/dataEntryTemplateGeneration"

//Lab documents start here

const LabDocumentFolders = () =>
  import(
    /* webpackChunkName: "routes" */ "@/components/labDocuments/LabDocumentFolders"
  )

// Lab documents end here

const CovidDrive = () =>
  import(/* webpackChunkName: "routes" */ "@/views/CovidDrive")

// Logistics

const LabInformation = () =>
  import(/* webpackChunkName: "routes" */ "@/views/labs/LabInformation.vue")

const icd10Codes = () =>
  import(
    /* webpackChunkName: "routes" */ "@/components/allIcd10Codes/Icd10Codes.vue"
  )

const updatePassword = () =>
  import(/* webpackChunkName: "routes" */ "@/components/UpdatePassword.vue")
const ProfileEdit = () =>
  import(/* webpackChunkName: "routes" */ "@/components/auth/ProfileEdit.vue")
const SupplementaryReportView = () =>
  import(
    /* webpackChunkName: "routes" */ "@/views/cases/SupplementaryReportView"
  )
const TestReports = () =>
  import(/* webpackChunkName: "routes" */ "@/views/cases/TestReports")
const ResultFileStatusDetailsReport = () =>
  import(
    /* webpackChunkName: "routes" */ "@/views/resultFiles/ResultFileStatusDetailsReport"
  )
const ResultFileStatusDetailsTestReports = () =>
  import(
    /* webpackChunkName: "routes" */ "@/views/resultFiles/ResultFileStatusDetailsTestReports"
  )
const ResultFileStatusDetailsBloodHTMLDATA = () =>
  import(/* webpackChunkName: "routes" */ "@/components/cases/HtmlReportView")
const ResultFileStatusDetailsUrineHTMLDATA = () =>
  import("@/components/cases/HtmlUrineReportPreview")
const ToxicologyTestResultsPreview = () =>
  import("@/components/cases/ToxicologyResultsPreview")

// const EditUserAccount = () => import("@/components/addUser/editUserAccount");
import(
  /* webpackChunkName: "routes" */ "@/components/cases/HtmlUrineReportPreview"
)

const ArchiveCases = () =>
  import(/* webpackChunkName: "routes" */ "@/components/cases/ArchiveCases")
const ArchiveOrders = () =>
  import(/* webpackChunkName: "routes" */ "@/components/orders/ArchiveOrders")

const LabCategoryFiles = () =>
  import(
    /* webpackChunkName: "routes" */ "@/components/labDocuments/LabDocumentsFiles"
  )

// cardaic reports

const EditHospitalPhysician = () =>
  import(
    /* webpackChunkName: "routes" */ "@/components/hospitals/physicians/HospitalPhysicianEdit.vue"
  )
const ToxicologyTestResults = () =>
  import(
    /* webpackChunkName: "routes" */ "@/components/cases/ToxicologyTestResults"
  )
const Toxicology = () =>
  import(
    /* webpackChunkName: "routes" */ "@/components/reports/toxicology/ReportPage.vue"
  )

const PatientReportPreview = () => import("@/views/PatientReportPreview")
const PatientEmailReportPreview = () => import("@/views/PatientReportEmailView")
const ErequisitionView = () => import("@/views/cases/ErequisitionView")
const ErequisitionViewOrders = () =>
  import("@/components/orders/ErequisitionViewOrders")
const Attachments = () => import("@/views/cases/Attachments")
const UaQcResults = () => import("@/components/cases/UaQcResults")
const UaBarcodes = () =>
  import(/* webpackChunkName: "routes" */ "@/views/cases/UaQcBarcodes")
const PrintUrinalysisResults = () =>
  import(/* webpackChunkName: "routes" */ "@/components/cases/PrintUaResults")
const AllConfigTests = () => import("@/components/bloodConfig/AllConfigTests")
const NetworkPayors = () => import("@/views/labs/NetworkPayors")
const AddConfigTests = () => import("@/components/bloodConfig/AddConfigTests")

const routes = [
  {
    path: "/",
    component: Home,

    children: [
      ...topdogRouters,
      ...CaseRouter,
      ...OrdersRouter,
      ...UserAccountsRouter,
      ...PendingCasesRouter,
      ...ResultFilesRouter,
      ...QCChartsRouter,
      ...SendOutsRouter,
      ...ReceivedSendOutsRouter,
      ...HospitalRouter,
      ...PhysicianRouter,
      ...InsurancesRouter,
      ...RuleBookRouter,
      ...EMRInsurancesRouter,
      ...BillingAutomationRulesRouter,
      ...ResendToRxntRouter,
      ...DataEntryTemplateGenerationRouter,
      {
        path: "/archive/cases",
        name: "ArchiveDataCases",
        component: ArchiveCases,
        beforeEnter: AuthMiddleware.user,
      },

      {
        path: "/archive/orders",
        name: "ArchiveDataOrders",
        component: ArchiveOrders,
        beforeEnter: AuthMiddleware.user,
      },
      {
        path: "/supply-request/success",
        name: "Supply-Request-Success",
        component: CovidDrive,
      },

      //labs

      {
        path: "/labs-documents",
        name: "LabDocumentFolders",
        component: LabDocumentFolders,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "LAB DOCUMENTS",
        },
      },

      {
        path: "/labs-documents/:folder_id/:folder_name",
        name: "LabCategoryFiles",
        component: LabCategoryFiles,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "Lab Documents",
        },
      },

      //labs

      {
        path: "/lab-information",
        name: "LabInformation",
        component: LabInformation,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "LABORATORY",
        },
      },

      {
        path: "/physician/:physician_id/edit",
        name: "EditHospitalPhysician",
        component: EditHospitalPhysician,
        meta: {
          title: "PHYSICIAN",
        },
      },

      {
        path: "/update-password",
        name: "updatePassword",
        component: updatePassword,
        meta: {
          title: "UPDATE PASSWORD",
        },
      },
      {
        path: "/user-profile",
        name: "Profile",
        beforeEnter: AuthMiddleware.user,
        component: Profile,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "USER PROFILE",
        },
      },
      {
        path: "/edit-profile",
        name: "ProfileEdit",
        component: ProfileEdit,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "PROFILE EDIT",
        },
      },

      {
        path: "/global-search",
        name: "GlobalSearch",
        component: GlobalSearch,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "GLOBAL SEARCH",
        },
      },

      {
        path: "/all-report-download",
        name: "Exports",
        component: Exports,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "REPORTS",
        },
      },
      {
        path: "/pharmacy-report-download",
        name: "PharmacyExports",
        component: PharmacyExports,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "PHARMACY REPORTS",
        },
      },

      {
        path: "/logs/cases",
        name: "casesLogs",
        component: CasesLogs,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "LOGS",
        },
      },
      {
        path: "/logs/orders",
        name: "ordersLogs",
        component: OrdersLogs,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "LOGS",
        },
      },
      {
        path: "/logs/emr-orders",
        name: "emrOrdersLogs",
        component: EMROrdersLogs,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "LOGS",
        },
      },
      {
        path: "/logs/result-files",
        name: "resultFileLogs",
        component: ResultFileLogs,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "LOGS",
        },
      },
      {
        path: "/logs/general-logs",
        name: "generalLogs",
        component: UserAccountLogs,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "LOGS",
        },
      },
      {
        path: "/logs/login-logs",
        name: "loginLogs",
        component: LoginUserLogs,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "LOGS",
        },
      },
      {
        path: "/logs/system-logs",
        name: "systemLogs",
        component: SystemLogs,
        beforeEnter: AuthMiddleware.labSuperAdmin,
        meta: {
          title: "SYSTEM LOGS",
        },
      },
      {
        path: "/instrument-queue",
        name: "InstrumentQueue",
        component: InstrumentQueue,
        beforeEnter: AuthMiddleware.releaseReports,
        meta: {
          title: "LAB CONSOLE",
        },
      },
      {
        path: "/email-logs",
        name: "EmailLogs",
        component: EmailLogs,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "EMAIL LOGS",
        },
      },
      {
        path: "/icd-10-codes",
        name: "icd10codes",
        component: icd10Codes,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "ICD 10 CODES",
        },
      },
      {
        path: "/toxicology-test-results/:result_file_id/report/:report_id/:test_results_id",
        name: "toxicology-test-results",
        component: ToxicologyTestResults,
        beforeEnter: AuthMiddleware.user,
      },
      {
        path: "/ua-qc-results",
        name: "UaQcResults",
        component: UaQcResults,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "UA QC RESULTS",
        },
      },
      {
        path: "/network-payors",
        name: "NetworkPayors",
        component: NetworkPayors,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "NETWORK PAYORS",
        },
      },
      {
        path: "/clinical-chemistry-tests",
        name: "ClinicalChemistryConfig",
        component: AllConfigTests,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "CONFIG TESTS",
        },
      },
      {
        path: "/clinical-chemistry-test/add",
        name: "AddClinicalChemistryConfig",
        component: AddConfigTests,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "ADD TEST",
        },
      },
      {
        path: "/clinical-chemistry-test/:test_id/edit",
        name: "Clinical-Chemistry-Test-Update",
        component: AddConfigTests,
        beforeEnter: AuthMiddleware.user,
        meta: {
          title: "TEST VIEW",
        },
      },
    ],
  },

  {
    path: "/cases/test-reports/:case_id",
    name: "ViewTestReports",
    component: TestReports,
    beforeEnter: AuthMiddleware.user,
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
  {
    path: "/signin",
    name: "signin",
    component: SignIn,
    beforeEnter: AuthMiddleware.guest,
  },

  {
    path: "/result-files/supplementary-report/:case_id/report/:report_id",
    name: "supplementaryReportView",
    component: SupplementaryReportView,
    beforeEnter: AuthMiddleware.user,
  },
  {
    path: "/result-files/:result_file_id/:report_id/:test_results_id",
    name: "ResultFileReport",
    component: ResultFileStatusDetailsReport,
    beforeEnter: AuthMiddleware.userOrServer,
  },
  {
    path: "/e-requisition-view-case/:case_id",
    name: "ErequisitionView",
    component: ErequisitionView,
    beforeEnter: AuthMiddleware.userOrServer,
  },
  {
    path: "/e-requisition-view-order/:order_id",
    name: "ErequisitionViewOrders",
    component: ErequisitionViewOrders,
    beforeEnter: AuthMiddleware.userOrServer,
  },
  {
    path: "/cases/attachments-view/:path",
    name: "ViewAttachments",
    component: Attachments,
    beforeEnter: AuthMiddleware.user,
  },
  {
    path: "/result-files/regular-report/:case_id/report/:report_id",
    name: "ResultFileTestReports",
    component: ResultFileStatusDetailsTestReports,
    beforeEnter: AuthMiddleware.userOrServer,
  },
  // html view
  {
    path: "/result-files/:case_id/report/:accession_id/blood-results",
    name: "ResultFileBloodHTMLData",
    component: ResultFileStatusDetailsBloodHTMLDATA,
    beforeEnter: AuthMiddleware.userOrServer,
  },
  {
    path: "/result-files/:case_id/report/:accession_id/urine-results",
    name: "ResultFileUrineHTMLData",
    component: ResultFileStatusDetailsUrineHTMLDATA,
    beforeEnter: AuthMiddleware.userOrServer,
  },
  {
    path: "/result-files/report/:case_id/toxicology-results",
    name: "ToxicologyTestResultsPreview",
    component: ToxicologyTestResultsPreview,
    beforeEnter: AuthMiddleware.userOrServer,
  },
  {
    path: "/result-files/:result_file_id/report/:report_id/:test_results_id/toxicology",
    name: "ResultFileToxicologyReport",
    component: Toxicology,
    beforeEnter: AuthMiddleware.userOrServer,
  },
  {
    path: "/order-e-requisition/:order_id/print",
    name: "ErequisitionPrintData",
    component: PrintRequisition,
    beforeEnter: AuthMiddleware.userOrServer,
  },
  {
    path: "/case-e-requisition/:case_id/print",
    name: "ErequisitionCasePrintData",
    component: PrintCaseRequisition,
    beforeEnter: AuthMiddleware.userOrServer,
  },
  // we wont include multiple barcodes in case children to avoid side navbar in case details
  {
    path: "/multiple-barcodes",
    name: "MultipleBarcodes",
    component: MultipleBarcodes,
    beforeEnter: AuthMiddleware.user,
  },
  {
    path: "/multiple-qrcodes",
    name: "MultipleQrcodes",
    component: MultipleQrcodes,
    beforeEnter: AuthMiddleware.user,
  },
  {
    path: "/orders/multiple-barcodes",
    name: "OrderMultipleBarcodes",
    component: OrderMultipleBarcodes,
    beforeEnter: AuthMiddleware.user,
  },
  {
    path: "/testgo-order-barcodes",
    name: "TestGOOrderBarcode",
    component: TestGOOrderBarcode,
    beforeEnter: AuthMiddleware.user,
  },
  {
    path: "/multiple-test-barcodes",
    name: "MultipleTestBarcodes",
    component: MultipleTestBarcodes,
    beforeEnter: AuthMiddleware.user,
  },
  {
    path: "/multiple-external-lab-barcodes",
    name: "MultipleExternalLabBarcodes",
    component: MultipleExternalLabBarcodes,
    beforeEnter: AuthMiddleware.user,
  },
  {
    path: "/patient-case-report/:report_id",
    name: "patient-report-preview",
    component: PatientReportPreview,
  },
  {
    path: "/patient-case-reports/:report_id",
    name: "patient-report-email-preview",
    component: PatientEmailReportPreview,
  },
  {
    path: "/ua-qc-barcodes",
    name: "QcBrcode",
    component: UaBarcodes,
    beforeEnter: AuthMiddleware.user,
  },
  {
    path: "/print-urinalysis-results",
    name: "PrintUrinalysisResults",
    component: PrintUrinalysisResults,
    beforeEnter: AuthMiddleware.user,
  },
  ...QCChartNonChildRoutes,
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
